import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dokumentService from "../../services/dokument.service";
import ConfirmDeleteModal from "../../components/ConfirmDeletModal";
import AddNewDocument from "./AddNewDokumentForm";
import { Modal, Row, Col, Button, Space, Dropdown, Menu } from "antd";
import SearchBar from "../../components/SearchBar";
import {
  TableOutlined,
  MenuOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import DokumentCards from "./DokumentCards";
import "./DokumentsPage.css";
import "./DokumentsPageKorisnik.css";
import Background from "../../components/Background4";
import DokumentsList from "./DokumentList";
import kategorijaDokumentaService from "../../services/kategorijaDokumenta.service";

function DokumentsPage() {
  const [dokumenti, setDokumenti] = useState([]);
  const [selecteIdDokumenta, setIdDokumenta] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isAddDocumentModalVisible, setIsAddDocumentModalVisible] =
    useState(false);
  const [searchTitle, setSearchTitle] = useState("");
  const [isListView, setListView] = useState(true);
  const [kategorijaDokumenta, setKategorijaDokumenta] = useState(null);
  const [sortCriteria, setSortCriteria] = useState("datumDodavanja");
  const [sortOrder, setSortOrder] = useState("asc");
  const { kategorijaDokumentaId } = useParams();

  const fetchDokumenti = useCallback(async () => {
    try {
      let result;
      if (kategorijaDokumentaId) {
        let kategorija = await kategorijaDokumentaService.getById(
          kategorijaDokumentaId
        );
        setKategorijaDokumenta(kategorija.data);
        result = await dokumentService.getDokumentiByKategorijaId(
          kategorijaDokumentaId
        );
      } else {
        result = await dokumentService.getAll();
      }
      setDokumenti(result.data);
    } catch (error) {
    }
  }, [kategorijaDokumentaId]);

  const showDeleteModal = (id) => {
    setIdDokumenta(id);
    setIsDeleteModalVisible(true);
  };

  const handleAddFile = () => {
    setIsAddDocumentModalVisible(true);
  };

  const handleDocumentAdded = () => {
    setIsAddDocumentModalVisible(false);
    fetchDokumenti();
  };
  const handleDeleteDokumenta = async () => {
    if (selecteIdDokumenta == null) return;
    try {
      await dokumentService.deleteDokument(selecteIdDokumenta);
      setDokumenti((prev) =>
        prev.filter((dokument) => dokument.id !== selecteIdDokumenta)
      );
    } catch (error) {
    } finally {
      setIsDeleteModalVisible(false);
      setIdDokumenta(null);
    }
  };

  useEffect(() => {
    fetchDokumenti();
  }, [fetchDokumenti]);

  const sortArticles = (articles) => {
    return articles.sort((a, b) => {
      let comparison = 0;
      if (sortCriteria === "datumDodavanja") {
        comparison = new Date(a.datumDodavanja) - new Date(b.datumDodavanja);
      } else if (sortCriteria === "naziv") {
        comparison = a.naziv.localeCompare(b.naziv);
      } else if (sortCriteria === "autor") {
        comparison = a.autor.localeCompare(b.autor);
      }
      return sortOrder === "asc" ? comparison : -comparison;
    });
  };

 const filtriraniDokumenti = dokumenti.filter((dokument) =>
    dokument.naziv.toLowerCase().includes(searchTitle.toLowerCase())
  );

  const sortedDokumenti = sortArticles([...filtriraniDokumenti]);
  const sortMenu = (
    <Menu onClick={(e) => setSortCriteria(e.key)}>
      <Menu.Item key="datumDodavanja">Datum Objave</Menu.Item>
      <Menu.Item key="naziv">Naziv</Menu.Item>
      <Menu.Item key="autor">Autor</Menu.Item>
    </Menu>
  );

  return (
    <div>
      <Background />
      <div className="docs-border">
        <div className="docs-container">
          <Row justify="center" align="middle" style={{ width: "90%" }}>
            <Col span={24}>
              <div className="page-title-and-search">
                {kategorijaDokumenta && (
                  <h1 className="page-title">{kategorijaDokumenta.naziv}</h1>
                )}
                <SearchBar
                  searchTitle={searchTitle}
                  setSearchTitle={setSearchTitle}
                />
              </div>
            </Col>
          </Row>

          <div className="AddButton-HeaderButton">
            <Row style={{ width: "100%" }}>
              <Col
                span={24}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button type="primary" onClick={handleAddFile}>
                  Dodaj novi dokument
                </Button>
              </Col>
            </Row>
            <Row style={{ width: "100%" }}>
              <Col
                span={24}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Space>
                  <Button
                    icon={isListView ? <TableOutlined /> : <MenuOutlined />}
                    onClick={() => setListView(!isListView)}
                  ></Button>
                  <Button
                    onClick={() =>
                      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
                    }
                  >
                    {sortOrder === "asc" ? <UpOutlined /> : <DownOutlined />}
                  </Button>
                  <Dropdown overlay={sortMenu} trigger={["click"]}>
                     <Button>
                      Sortiraj
                      <DownOutlined />
                    </Button>
                  </Dropdown>
                </Space>
              </Col>
            </Row>
          </div>

          <div className="dokument-list-div">
            {isListView ? (
              <DokumentsList
                dokumenti={sortedDokumenti}
                onDeleteClick={showDeleteModal}
              />
            ) : (
              <DokumentCards
                dokumenti={sortedDokumenti}
                onDeleteClick={showDeleteModal}
              />
            )}
          </div>

          <ConfirmDeleteModal
            visible={isDeleteModalVisible}
            onConfirm={handleDeleteDokumenta}
            onCancel={() => setIsDeleteModalVisible(false)}
          />

          <Modal
            className="docs-zaposleni add-modal"
            visible={isAddDocumentModalVisible}
            onCancel={() => setIsAddDocumentModalVisible(false)}
            footer={null}
          >
            <AddNewDocument
              onCancel={() => setIsAddDocumentModalVisible(false)}
              onDocumentAdded={handleDocumentAdded}
            />
          </Modal>
        </div>
      </div>
    </div>
  );
}

export default DokumentsPage;
